import React, { useState } from "react";
import {
  View,
  TouchableOpacity,
  TextInput,
  StyleSheet,
  ImageBackground,
  ActivityIndicator,
} from "react-native";
import AttachmentIcon from "@assets/svg/AttachmentIcon";
import SendMessageIcon from "@assets/svg/SendMessageIcon";
import PlusThin from "@assets/svg/PlusThin";
import CloseIcon from "@assets/svg/CloseIcon";
import Text from "@components/CustomText";
import colors from "@constants/color";

const MessageInput = (props) => {
  const {
    onClickAttachment = () => {},
    onCloseAttachment = () => {},
    removeImage = () => {},
    attachments = [],
    message,
    onChangeText,
    onSendMessage,
    active,
  } = props;

  const [inputHeight, setInputHeight] = useState(0);
  return (
    <View style={styles.container}>
      <View style={[styles.inputWrapper]}>
        <TouchableOpacity onPress={onClickAttachment}>
          <View style={styles.leftIconWrapper}>
            <AttachmentIcon />
          </View>
        </TouchableOpacity>
        <View
          style={{
            flex: 1,
            marginLeft: 5,
            marginBottom: 2,
          }}
        >
          <TextInput
            value={message}
            onChangeText={onChangeText}
            onChange={() => onCloseAttachment()}
            multiline
            onContentSizeChange={({
              nativeEvent: {
                contentSize: { width, height },
              },
            }) => {
              setInputHeight(height);
            }}
            placeholder="यहाँ मैसेज लिखें... "
            style={{
              fontSize: 16,
              height: Math.max(42, inputHeight),
              // flex: 1,
            }}
          />
        </View>
        <TouchableOpacity
          onPress={() => {
            onSendMessage(() => setInputHeight(0));
          }}
          disabled={!active}
        >
          <View>
            <View
              style={[
                styles.sendButton,
                {
                  backgroundColor: active
                    ? colors.primary
                    : "rgba(0, 0, 0, 0.1)",
                },
              ]}
            >
              <SendMessageIcon
                fill={active ? "#FFFFFF" : "#000"}
                fillOpacity={active ? 1 : 0.36}
              />
            </View>
          </View>
        </TouchableOpacity>
      </View>
      <View>
        <View style={{ marginVertical: 5, flex: 1, marginLeft: 30 }}>
          <View
            style={{
              flexDirection: "row",
              flexWrap: "wrap",
            }}
          >
            {attachments.map(({ url, source, id }, index) =>
              url || source ? (
                <ImageBackground
                  key={index}
                  style={{
                    height: 70,
                    width: 70,
                    borderRadius: 6,
                    borderWidth: 2,
                    borderColor: "rgba(0, 0, 0, 0.2)",
                    backgroundColor: "white",
                    alignItems: "center",
                    justifyContent: "center",
                    borderStyle: "solid",
                    marginBottom: 10,
                    overflow: "hidden",
                    marginRight: 10,
                  }}
                  source={url ? { uri: url } : source}
                >
                  <TouchableOpacity
                    onPress={() => removeImage(id)}
                    style={{
                      position: "absolute",
                      right: 0,
                      top: 0,
                      backgroundColor: "#ffffff66",
                      borderRadius: 15,
                      borderColor: "#e6e6e6",
                      borderWidth: 1,
                      width: 30,
                      height: 30,
                      alignItems: "center",
                      justifyContent: "center",
                      zIndex: 5,
                    }}
                  >
                    <View>
                      <CloseIcon />
                      {source && !url && (
                        <View
                          style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: "rgba(0,0,0,0.1)",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ActivityIndicator
                            size="large"
                            color={colors.primary}
                          />
                        </View>
                      )}
                    </View>
                  </TouchableOpacity>
                </ImageBackground>
              ) : null,
            )}
          </View>
        </View>
      </View>
    </View>
  );
};

export default MessageInput;

const styles = StyleSheet.create({
  container: {
    position: "absolute",
    bottom: 0,
    width: "100%",
    backgroundColor: "white",
    // minHeight: 50,
    elevation: 15,
    zIndex: 5,
    padding: 5,
  },
  sendButton: {
    borderRadius: 50,
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    marginLeft: 8,
  },
  inputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    paddingLeft: 20,
    paddingRight: 5,
    paddingVertical: 3,
  },
  leftIconWrapper: {
    paddingHorizontal: 10,
    paddingLeft: 0,
    paddingVertical: 7,
  },
});

const AddPhotoButton = () => {
  return (
    <TouchableOpacity>
      <View
        style={{
          width: 70,
          height: 70,
          backgroundColor: "lightgrey",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: 15,
        }}
      >
        <PlusThin />
      </View>
    </TouchableOpacity>
  );
};
